import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Form } from 'antd';
import styles from './Login.module.css';
import { loginUser, licenseValidate, licenseUpdate } from './Login.saga';
import LoginForm from './Login';
// import ForgotPassword from './ForgotPassword/UserPasswordReset';
import LicenceUpload from './Components/LicenceUpload';
// import AdminPasswordReset from './ForgotPassword/AdminPasswordReset';

const UserLogin = Form.create({
  name: 'user_login',
})(LoginForm);
// const ForgotPasswordForm = Form.create({ name: 'forgot_password_user' })(ForgotPassword);
// const AdminPasswordResetForm = Form.create({ name: 'forgot_password_admin' })(AdminPasswordReset);
const LicenceUploadForm = Form.create({
  name: 'licence_upload',
})(LicenceUpload);

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFirstVerification: false,
      isLicenseValid: true,
    };
  }

  componentDidMount() {
    // this.props.licenseValidate({
    // 	callback: (values) => {
    // 		this.handleLicenseKey(values)
    // 	}
    // })
  }

  handleLicenseKey = (values) => {
    this.setState(
      {
        isFirstVerification: values.isFirstVerification,
        isLicenseValid: values.isLicenseValid,
      },
      () => {
        // this.state.isLicenseValid && this.props.fetchLanguages()
      }
    );
  };

  // forgotPasswordUser = () => {
  // 	this.props.selectForm(1)
  // }
  // resetKey = () => {
  // 	this.props.selectForm(2)
  // }
  login = (loginInfo) => {
    const data = {
      password: loginInfo.password,
      userName: loginInfo.username,
    };
    this.props.loginUser({
      data,
      remember: loginInfo.remember,
    });
  };
  // getResetKey = (values) => {
  // 	this.props.resetKey({ data: values })
  // }
  // adminPasswordReset = (values) => {
  // 	this.props.resetAdminPassword(values)
  // }
  // navigateToLogin = () => {
  // 	this.props.selectForm(0)
  // }
  // navigateToRequestResetKey = () => {
  // 	this.props.selectForm(1)
  // }

  render() {
    const { isFirstVerification, isLicenseValid } = this.state;
    const { passwordForm, resetAdminPassword, licenseUpdate } = this.props;
    return (
      <div className={styles.wrapper}>
        {isLicenseValid ? (
          <>
            <div className={styles.logoWrapper}>
              <div className={styles.logoHolder} />
              <div className={styles.titleName}>
                <span>Runtime</span>
                <span>Vision AI</span>
              </div>
            </div>
            <div className={styles.logoWrapper}>
              {isLicenseValid ? (
                passwordForm === 0 ? (
                  <UserLogin loginData={this.login} />
                ) : passwordForm === 1 ? (
                  <div />
                ) : (
                  <div />
                )
              ) : (
                // <ForgotPasswordForm resetKeyForm={this.resetKey} goToLogin={this.navigateToLogin}
                // 	resetUserPassword={this.getResetKey} /> :
                // <AdminPasswordResetForm resetAdminPassword={resetAdminPassword} gotToReset={this.navigateToRequestResetKey}
                // 	adminPassword={this.adminPasswordReset} />
                ''
              )}
            </div>
          </>
        ) : (
          <LicenceUploadForm
            updateLicenseKey={licenseUpdate}
            licenseExpired={{
              isFirstVerification,
              isLicenseValid,
            }}
            handleIsLicensed={() =>
              this.handleLicenseKey({
                isFirstVerification: false,
                isLicenseValid: true,
              })
            }
          />
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    passwordForm: state.loginReducer.passwordForm,
  }),
  {
    loginUser,
    // resetKey,
    // resetAdminPassword,
    // selectForm,
    licenseValidate,
    licenseUpdate,
  }
)(Login);
